import { Empty } from "@/components/Empty";
import SubLayout from "@/components/SubLayout";
import { CapsuleTabs } from "antd-mobile";
import { useMemo, useState } from "react";
import { Process } from "./Process";
import { data } from "./data";
import styles from "./index.module.scss";
import { useParams, useSearchParams } from "react-router-dom";

type Help = {
  type: string;
  title: string;
};

const helps: Help[] = [
  { title: "实名", type: "1" },
  { title: "收付", type: "2" },
  { title: "卖币", type: "3" },
  { title: "买币", type: "4" },
  { title: "充值", type: "5" },
  { title: "提现", type: "6" },
  { title: "交易所交易教程", type: "7" },
];

export function PageHelp() {
  const search = useSearchParams();
  const [active, setActive] = useState<string>(search[0].get('index') || '1');

  const content = useMemo(() => {
    return active && data[active as string] ? data[active] : null;
  }, [active]);

  return (
    <SubLayout title={"帮助中心"}>
      <div className={styles.page}>
        <CapsuleTabs activeKey={active} onChange={setActive}>
          {helps.map((help) => {
            return <CapsuleTabs.Tab title={help.title} key={help.type} />;
          })}
        </CapsuleTabs>

        <section className={styles.content_wrapper} key={content?.title}>
          <div className={styles.content_header}>
            <div className={styles.content_header_content}>
              <div className={styles.content_title_left}></div>
              <div className={styles.content_title}>
                {content?.title || "标题"}
              </div>
              <div className={styles.content_title_right}></div>
            </div>
          </div>

          <div className={styles.content_text}>
            {content ? (
              <Process title={content?.title} steps={content?.steps} />
            ) : (
              <Empty />
            )}
          </div>
        </section>
        {/* </CapsuleTabs> */}
      </div>
    </SubLayout>
  );
}
